import React from 'react';

function AuthAside({ eyebrow, title, subtitle, benefits, foot }) {
  return (
    <aside className="auth-aside">
      <span className="blob b1" />
      <span className="blob b2" />
      <div className="aside-eyebrow">{eyebrow}</div>
      <h2 className="aside-title">{title}</h2>
      <p className="aside-sub">{subtitle}</p>
      {benefits && benefits.length > 0 && (
        <ul className="benefits">
          {benefits.map((item) => (
            <li key={item}>
              <span className="tick">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </span>
              {item}
            </li>
          ))}
        </ul>
      )}
      {foot}
    </aside>
  );
}

export function AuthAsideTrustFoot() {
  return (
    <div className="aside-foot">
      <div className="avatars">
        <span>JA</span>
        <span>MO</span>
        <span>RK</span>
      </div>
      Trusted by 1,200+ sales professionals
    </div>
  );
}

export function AuthAsideLockFoot() {
  return (
    <div className="aside-foot">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--cream)' }}>
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0110 0v4" />
      </svg>
      Protected by bank-grade encryption
    </div>
  );
}

export default AuthAside;
